import { InjectionToken } from '@angular/core';
import { ICultureSettings } from './iculture-settings.model';

export const CULTURE_SERVICE = new InjectionToken<ICultureService>('ICultureService');

export interface ICultureService {
  getCultureSettings(): ICultureSettings;
}
